import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '@State'
import { ActionButton } from './ActionButton'
import { EditSectionNameModal, editSectionNameItem } from './EditSectionNameModal'
import { RemoveSectionModal, removeSectionItem } from './RemoveSectionModal'
import { SetExpirationModal, setExpirationItem } from './SetExpirationModal'
import { ArchiveSectionModal, archiveSectionItem } from './ArchiveSectionModal'

export const ActionButtonSection = ({ section, sectionName }) => {
  const [currentState] = useStateValue()
  const items = [
    editSectionNameItem,
    setExpirationItem,
    archiveSectionItem,
    ...(currentState.allSectionData.length > 1
      ? [
          { id: 'remove-separator', separator: true },
          removeSectionItem,
        ]
      : []),
  ]

  return (
    <ActionButton items={items}>
      {({ activeAction, close }) => (
        <Fragment>
          <EditSectionNameModal
            section={section}
            sectionName={sectionName}
            show={activeAction === editSectionNameItem.id}
            close={close}
          />
          <RemoveSectionModal
            section={section}
            sectionName={sectionName}
            show={activeAction === removeSectionItem.id}
            close={close}
          />
          <SetExpirationModal
            section={section}
            show={activeAction === setExpirationItem.id}
            close={close}
          />
          <ArchiveSectionModal
            section={section}
            sectionName={sectionName}
            show={activeAction === archiveSectionItem.id}
            close={close}
          />
        </Fragment>
      )}
    </ActionButton>
  )
}

ActionButtonSection.propTypes = {
  section: PropTypes.string,
  sectionName: PropTypes.string,
}
